import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { canvasAnnotationStoreAtom, consensusAnnotationFramesAtom, mlAnnotationFramesAtom } from '../../../../labelling-v2/atoms/annotation-atoms';
import { currentFrameAtom } from '../../../../labelling-v2/atoms/video-playback-atoms';
import { filterSegmentationAnnotations, loadAnnotationBitmaps } from '../canvas/utils';
const asyncCurrentFrameAnnotationBitmapsAtom = atom(async get => {
  const currentFramesCanvasAnnotationStore = get(canvasAnnotationStoreAtom);
  const currentFrame = get(currentFrameAtom);
  const currentFramesMlAnnotationStore = get(mlAnnotationFramesAtom).get(currentFrame);
  const currentFramesConsensusAnnotationStore = get(consensusAnnotationFramesAtom).get(currentFrame);
  const annotations = filterSegmentationAnnotations(currentFramesCanvasAnnotationStore, currentFramesMlAnnotationStore, currentFramesConsensusAnnotationStore);
  return loadAnnotationBitmaps(annotations, false);
});

// Derived atom: decodes base64 → ImageData whenever current frame annotations change.
// Preserves the previous value while reloading so consumers never see empty bitmaps mid-update.
export const currentFrameAnnotationBitmapsAtom = unwrap(asyncCurrentFrameAnnotationBitmapsAtom, prev => prev ?? {});
export type AnnotationPixelMap = {
  width: number;
  height: number;
  titleToId: Record<string, number>;
  idToTitle: string[];
  getBitmapId: (x: number, y: number) => number | null;
};
export const annotationPixelMapAtom = atom<AnnotationPixelMap | undefined>(undefined);